import { render, staticRenderFns } from "./Property.vue?vue&type=template&id=05ad3503&"
import script from "./Property.vue?vue&type=script&lang=js&"
export * from "./Property.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports